export class CourseFoldersFactory {
  constructor(instance) {
    this.instance = instance;
  }

  getCourseFolders() {
    return this.instance.get('/v1/course-folders');
  }

  insertCourseFolder(data) {
    return this.instance.post('/v1/course-folders', data);
  }

  updateCourseFolder(data, id) {
    return this.instance.put(`/v1/course-folders/${id}`, data);
  }

  deleteCourseFolder(id) {
    return this.instance.delete(`/v1/course-folders/${id}`);
  }
}

export default (...params) => new CourseFoldersFactory(...params);
